import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SliceType } from '~/enums/SliceType';

import { RootState } from '../../types';
import { BannerState, State } from './types';

const initialState = {} as State;

const name = SliceType.Pages;

const selectAllPages = (state: RootState) => state.pages;

export const selectPageBanner = createSelector(
  [selectAllPages, (_: RootState, pathname: string) => pathname],
  (pages, pathname): BannerState | undefined => pages[pathname]?.banner,
);
const pages = createSlice({
  name,
  initialState,
  reducers: {
    clearPageBanner: (
      state: State,
      action: PayloadAction<{ pathname: string }>,
    ) => {
      const { pathname } = action.payload;
      delete state[pathname]?.banner;
    },
    setPageBanner: (
      state: State,
      action: PayloadAction<{ banner: BannerState; pathname: string }>,
    ) => {
      const { banner, pathname } = action.payload;
      if (!state[pathname]) {
        state[pathname] = {};
      }
      state[pathname].banner = banner;
    },
  },
});

export default pages;
